// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"_b684e4e","innerContainer":"_2b4218c9","content":"_96a83cf9","title":"_ee185850"};